import React, { useMemo, useState } from "react";
import SearchWithDropdown from "../../components/form/front/SearchWithDropdown";
import Dropdown from "../../components/form/Dropdown";
import Button from "../../components/form/front/Button";
import Select from "../../components/form/front/Select";
import Tabs from "../../components/elements/Tabs";
import { useTabQuery } from "../../hooks/useTabQuery";
import MessagesSection from "../../components/sections/front/MessagesSection";

const Messages = () => {
  const [keyword, setKeyword] = useState("");
  const [value, setValue] = useState(null);
  const [showUnread, setShowUnread] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const profileMenu = [
    {
      _id: 1,
      name: "My Profile",
      icon: "fa-regular fa-user",
      //   link: notificationLink,
    },
    {
      _id: 2,
      name: "Create Company",
      icon: "fa-regular fa-plus",
      //   link: "/manage-company",
    },
    {
      _id: 3,
      name: "Help",
      icon: "fa-regular fa-circle-question",
      //   link: "/help",
    },
  ];

  const formattingOptions = [
    { value: 1, name: "Inbox" },
    { value: 2, name: "Archived" },
  ];

  const messageViewOptions = [
    { value: "inbox", name: "Inbox" },
    { value: "unread", name: "Unread" },
  ];

  const handleSelectChange = (value, item) => {
    console.log("Selected Value:", value);
    console.log("Selected Item:", item);
    setValue(value);
  };

  return (
    <section className="bg-white border border-zinc-300 rounded-lg overflow-hidden">
      <div className="w-full p-3 border-b">
        <div className="flex gap-1 items-center justify-between">
          
          <div className="text-base font-semibold text-gray-900">Messaging</div>

          {/* <div className="w-[70%] hidden md:block">
            <SearchWithDropdown
              placeholder="Search jobs"
              keyword={keyword}
              setKeyword={setKeyword}
              xPlacement="bottom"
              divClasses="px-1 h-8 rounded-md bg-white border border-zinc-300 shadow-none"
              inputClasses="pr-24 placeholder:text-sm"
              icon="fa-light fa-search"
              iconClasses="text-black text-base dark:text-gray-100 pr-1"
            />
          </div> */}
          {
            showChat && (
              <Button
                buttonFunction={() => setShowChat(false)}
                buttonIcon={"fa-solid fa-arrow-left-long"}
                buttonLabel={"Back"}
                buttonClasses={"h-6 bg-transparent text-black text-sm gap-1 block md:hidden"}
                buttonLabelClasses={"text-sm"}
                
              />
            )
          }
        </div>

        {/* <div className="flex gap-4 items-center w-1/2 justify-end">
          <Dropdown
            data={profileMenu}
            xPlacement="bottomRight"
            dropdownContainer="w-72"
            buttonClasses="p-0 border-0 !text-xl text-gray-800"
            variantClass="mt-4"
            itemclasses="last:border-b-2"
            button={<i class="fa-solid fa-ellipsis"></i>}
          />
          <Button
            buttonIcon={"fa-regular fa-pen-to-square"}
            buttonClasses={"!rounded-full hover:!bg-primary hover:text-white w-8 h-8 !bg-slate-100 text-gray-800"}
            buttonLabelClasses={"!text-xs "}
            buttonType={"submit"}
          />
        </div> */}
      </div>
      <div className="w-full flex gap-4 justify-between items-center px-4  py-2">
        {/* <div className="flex gap-4 items-center w-[120px] justify-start">
          <Select
            placeholder={"Inbox"}
            dropdownButtonClass={"h-8 rounded-full bg-palatte !text-white font-semibold"}
            selectPlaceholder="text-white"
            selectDropdownIcon={"text-white text-bold"}
            dropdownData={formattingOptions}
            onChange={handleSelectChange}
            selectedValue={value}
          />
        </div> */}

        {/* <Tabs
            items={tabs}
            selectedIndex={selectedIndex}
            setSelectedIndex={handleTabChange}
            tabsClass="gap-10 w-full bg-white before:border-b-0"
            underLineClass="hidden"
            tabsButtonsClass="pb-0"
          /> */}
        {/* <Button
          buttonLabel={"Unread"}
          buttonFunction={() => setShowUnread((prev) => !prev)}
          buttonClasses={`rounded-full border font-semibold h-8 ${
            showUnread
              ? "bg-emerald-600 text-white border-emerald-600"
              : "bg-transparent border-gray-400 text-gray-700"
          }`}
        /> */}
        <div className="flex gap-4 items-center w-[120px] justify-start">
          <Select
            placeholder={"Inbox"}
            dropdownButtonClass={
              "h-8 rounded-full bg-palatte !text-white font-semibold px-3 hover:!text-white"
            }
            selectPlaceholder="text-white"
            selectDropdownIcon={"text-white"}
            dropdownData={messageViewOptions}
            selectedValue={value || "inbox"}
            onChange={(val) => {
              setValue(val);
              setShowUnread(val === "unread"); // 🔥 control logic here
            }}
          />
        </div>
      </div>
      <MessagesSection
        showUnread={showUnread}
        showChat={showChat}
        setShowChat={setShowChat}

      />
    </section>
  );
};

export default Messages;
